import { Controller } from "@hotwired/stimulus"

// Lightweight styled select modeled on RubyUI's Select. A hidden input carries
// the value so it submits with the surrounding form; the trigger shows the
// current label and the popover lists the options.
export default class extends Controller {
  static targets = ["trigger", "content", "input", "value", "item"]

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    this.boundKeydown = this.keydown.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    if (this.contentTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.boundClickOutside)
    document.addEventListener("keydown", this.boundKeydown)
  }

  close() {
    this.contentTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  select(event) {
    const value = event.params.value
    const label = event.currentTarget.textContent.trim()

    if (this.hasInputTarget) {
      this.inputTarget.value = value
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    if (this.hasValueTarget) {
      this.valueTarget.textContent = label
    }
    this.itemTargets.forEach(item => {
      item.setAttribute("aria-selected", item === event.currentTarget ? "true" : "false")
    })

    this.close()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundKeydown)
  }
}
